export const enum TabsDepositsEnum {
  Deposits = 1,
  Detail = 2,
  LockBox = 3,
  Posted = 4,
  Conciliation = 5,
  OfficeDeposit = 6,
  Electronic = 7,
  WriteOff = 8
}

export const enum TabsElectronicEnum {
  Claims = 1,
  ClaimsDetail = 2,
  RemitSummary = 3
}

export const enum OptionImportEnum {
  Deposits = 1,
  Posted = 2,
  LockBox = 3
}

export const enum ModalNameEnum {
  Deposits = 1,
  ImportFile = 2,
  NoteDetails = 3,
  CopyPasteDepositDetails = 4,
  HistoryDetails = 5
}

export const enum DepositsStatusEnum {
  Pending = 1,
  NotFound = 2,
  OverPosted = 3,
  Completed = 4,
  Incomplete = 5,
  Misapplied = 6,
  NoEoB = 7,
  Trip2 = 8,
  Covalent = 9,
  Posted = 10
}

export const enum StepperEnum {
  Start = 1,
  Previous = 2,
  Next = 3,
  End = 4
}

export const enum AgButtonsEnum {
  RemoveFilter = 1,
  RemoveSort = 2
}

export const DepositAction = {
  ChangeTab: 'changeTab',
  ChangeTabFromDetail: 'changeTabFromDetail',
  ChangeTabFromConciliation: 'changeTabFromConciliation',
  Save: 'save',
  Update: 'update',
  SearchLogBox: 'searchLogBox',
  SearchPosted: 'searchPosted',
  SearchConciliation: 'searchConciliation',
  SearchOfficeDeposit: 'SearchOfficeDeposit',
  SearchElectronic: 'SearchElectronic',
  BulkSave: 'bulkSave',
  StepperActionButton: 'stepperActionButton',
  StepperActionButtonResp: 'stepperActionButtonResp',
  AutoFillActionButton: 'autoFillActionButton',
  AutoFillActionButtonResp: 'autoFillActionButtonResp',
  OpenCopyPasteModal: 'openCopyPasteModal',
  UpdateGridAfterCloseCopyPasteModal: 'updateGridAfterCloseCopyPasteModal',
  AutoFillDetailPayor: 'autoFillDetailPayor',
  MonthPickerSetterValueChangesDeposit: 'monthPickerSetterValueChangesDeposit',
  MonthPickerSetterValueChangesLockBoxResp: 'monthPickerSetterValueChangesLockBoxResp',
  MonthPickerSetterValueChangesPostedResp: 'monthPickerSetterValueChangesPostedResp',
  MonthPickerSetterValueChangesConciliationResp: 'monthPickerSetterValueChangesConciliationResp',
  MonthPickerSetterValueChangesElectronicResp: 'monthPickerSetterValueChangesElectronicResp',
  ShowDenialReasonsAfterDoubleClick: 'showDenialReasonsAfterDoubleClick'
};

export const EventModal = {
  Cancel: 'cancel',
  Close: 'close',
  Overlay: 'overlay'
};

export const DepositActions = {
  DepositTab: 'DepositTab',
  DepositDetailTab: 'DepositDetailTab',
  LockBoxTab: 'LockBoxTab',
  PostedDelete: 'PostedDelete',
  DepositDelete: 'DepositDelete',
  PostedUpdateLockBoxStatus: 'LockBoxUpdateStatus',
  PostedCopy: 'PostedCopy',
  PostedEdit: 'PostedEdit',
  OfficeDepositDelete: 'OfficeDepositDelete',
};

export const DepositGridName = {
  DepositGrid: 'DepositGrid',
  PostedGridRight: 'PostedGridRight',
  PostedGrid: 'PostedGrid',
  LockBoxGrid: 'LockBoxGrid'
};

export enum ElectronicGridEnum {
  UpperGridOpt,
  ClaimDetailGrid,
  RemitGrid,
  LowerGridOpt,
  DenialReasonsGrid,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-deposits.enum.ts